import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputWrapper from "../../citizen/AVPForms/layout/inputWrapper";
import { Button } from "@mui/material";
import { useForm } from "react-hook-form";
import { Table } from "react-bootstrap";
import { recommendation } from "../../citizen/TCPForms/data";
import { useDispatch } from "react-redux";
import { updateDocument } from "@egovernments/digit-ui-module-core/src/redux/actions/remarksDialog";

const RemarksDialog = ({ open, handleClose, doc }) => {
  const { control, handleSubmit } = useForm();
  const dispatch = useDispatch();
  console.log("docInDIalog", doc);

  const onSubmit = (data) => {
    console.log("dataFromModalBefore", data);
    data = {
      ...doc,

      ...data,
    };
    // Dispatch Redux action to update recommendation
    // dispatch(updateDocument({ docId: doc.id, docStatus: data?.docStatus, recommendation: data?.documentRemarks }));
    console.log("dataFromModalAfter", data);
    dispatch(updateDocument(data));
    handleClose();
  };

  // if (!doc) return "Not a valid document";

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          maxWidth: "70%",
          width: "70%",
        },
        component: "form",
        onSubmit: (event) => {
          event.preventDefault();
          handleSubmit(onSubmit)(event);
        },
      }}
    >
      <DialogTitle style={{ backgroundColor: "#1f4a7c", color: "white" }}>{doc?.additionalDetails?.title || doc?.documentType}</DialogTitle>
      <DialogContent>
        <Table striped bordered className="m-0">
          <tbody>
            <tr>
              <td style={{ textAlign: "center", minWidth: "fit-content" }}>{doc?.additionalDetails?.title || doc?.documentType}</td>
              {/* <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                <InputWrapper
                  hasLabel={false}
                  type="selectInput"
                  control={control}
                  data={recommendation}
                  placeholder={"Select document status"}
                  name="documentStatus"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </td> */}
              <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                <InputWrapper
                  hasLabel={false}
                  type="textInput"
                  control={control}
                  name="remarks"
                  multiLine={true}
                  // height={"60px"}
                  placeholder={"Enter remarks"}
                  mandatory
                  inputClassName={"document-remark"}
                  maxLength={150}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit">Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemarksDialog;
